import { render, staticRenderFns } from "./_Private.vue?vue&type=template&id=983fe024&scoped=true&"
import script from "./_Private.vue?vue&type=script&lang=js&"
export * from "./_Private.vue?vue&type=script&lang=js&"
import style0 from "./_Private.vue?vue&type=style&index=0&id=983fe024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983fe024",
  null
  
)

export default component.exports